
// ======================== 模拟数据 ========================

// 模拟模型数据
const mockModels = [
  {
    id: 1,
    name: 'GPT-4 Turbo',
    description: '最新的GPT-4模型，支持更长的上下文和更快的推理速度，适用于复杂的自然语言处理任务',
    image: 'https://picsum.photos/400/300?random=1',
    tags: ['自然语言处理', 'GPT', '大语言模型', '对话系统'],
    rating: 4.8,
    views: 125400,
    downloads: 15600,
    stars: 2340,
    featured: true,
    category: 'nlp',
    author: {
      name: 'OpenAI',
      avatar: 'https://picsum.photos/50/50?random=101'
    },
    updatedAt: '2024-12-18T10:30:00Z'
  },
  {
    id: 2,
    name: 'DALL-E 3',
    description: '先进的文本到图像生成模型，能够根据详细的文本描述创建高质量、逼真的图像',
    image: 'https://picsum.photos/400/300?random=2',
    tags: ['图像生成', '文本到图像', 'AI艺术', '创意设计'],
    rating: 4.7,
    views: 98700,
    downloads: 12300,
    stars: 1890,
    featured: true,
    category: 'computer_vision',
    author: {
      name: 'OpenAI',
      avatar: 'https://picsum.photos/50/50?random=101'
    },
    updatedAt: '2024-12-17T14:22:00Z'
  },
  {
    id: 3,
    name: 'Whisper Large V3',
    description: '多语言语音识别模型，支持99种语言的自动语音识别和语音翻译',
    image: 'https://picsum.photos/400/300?random=3',
    tags: ['语音识别', '多语言', '语音转文本', '实时转录'],
    rating: 4.6,
    views: 76500,
    downloads: 8900,
    stars: 1456,
    category: 'audio',
    author: {
      name: 'OpenAI',
      avatar: 'https://picsum.photos/50/50?random=101'
    },
    updatedAt: '2024-12-16T09:15:00Z'
  },
  {
    id: 4,
    name: 'Claude 3 Opus',
    description: '先进的AI助手模型，擅长复杂推理、创作和分析任务，具有强大的上下文理解能力',
    image: 'https://picsum.photos/400/300?random=4',
    tags: ['AI助手', '推理', '创作', '分析'],
    rating: 4.9,
    views: 156800,
    downloads: 18700,
    stars: 2890,
    featured: true,
    category: 'nlp',
    author: {
      name: 'Anthropic',
      avatar: 'https://picsum.photos/50/50?random=102'
    },
    updatedAt: '2024-12-18T16:45:00Z'
  },
  {
    id: 5,
    name: 'Stable Diffusion XL',
    description: '高分辨率图像生成模型，支持1024x1024分辨率的图像生成，质量卓越',
    image: 'https://picsum.photos/400/300?random=5',
    tags: ['图像生成', '高分辨率', 'Diffusion', '艺术创作'],
    rating: 4.5,
    views: 134200,
    downloads: 16800,
    stars: 2156,
    category: 'computer_vision',
    author: {
      name: 'Stability AI',
      avatar: 'https://picsum.photos/50/50?random=103'
    },
    updatedAt: '2024-12-15T11:30:00Z'
  },
  {
    id: 6,
    name: 'LLaMA 2 70B',
    description: '开源大语言模型，70B参数版本，在多项基准测试中表现优异',
    image: 'https://picsum.photos/400/300?random=6',
    tags: ['开源', '大语言模型', 'LLaMA', '基础模型'],
    rating: 4.4,
    views: 89600,
    downloads: 11200,
    stars: 1678,
    category: 'nlp',
    author: {
      name: 'Meta AI',
      avatar: 'https://picsum.photos/50/50?random=104'
    },
    updatedAt: '2024-12-14T13:20:00Z'
  },
  {
    id: 7,
    name: 'Mistral 7B Instruct',
    description: '高效的指令遵循模型，在保持小体积的同时提供出色的性能',
    image: 'https://picsum.photos/400/300?random=7',
    tags: ['指令遵循', '高效', '小模型', '开源'],
    rating: 4.3,
    views: 67800,
    downloads: 9400,
    stars: 1234,
    category: 'nlp',
    author: {
      name: 'Mistral AI',
      avatar: 'https://picsum.photos/50/50?random=105'
    },
    updatedAt: '2024-12-13T08:45:00Z'
  },
  {
    id: 8,
    name: 'YOLOv8',
    description: '最新版本的YOLO目标检测模型，速度更快，精度更高',
    image: 'https://picsum.photos/400/300?random=8',
    tags: ['目标检测', 'YOLO', '实时检测', '计算机视觉'],
    rating: 4.6,
    views: 103400,
    downloads: 13700,
    stars: 1987,
    category: 'computer_vision',
    author: {
      name: 'Ultralytics',
      avatar: 'https://picsum.photos/50/50?random=106'
    },
    updatedAt: '2024-12-12T15:10:00Z'
  }
]

// 模拟容器数据
const mockContainers = [
  {
    id: 'container-001',
    name: 'pytorch-gpu-dev',
    type: 'development',
    status: 'running',
    image: 'pytorch/pytorch:2.1.0-cuda11.8-devel',
    spec: {
      cpu: '4 vCPU',
      memory: '16 GB',
      gpu: 'NVIDIA A100 40GB',
      storage: '100 GB SSD'
    },
    ip: '10.0.1.15',
    port: 8888,
    billing: {
      type: 'hourly',
      cost: 3.2,
      currency: 'USD'
    },
    tags: ['PyTorch', '深度学习', '开发环境'],
    createdAt: '2024-12-19T08:30:00Z',
    uptime: '2天5小时',
    resources: {
      cpu: 45,
      memory: 68,
      gpu: 82,
      network: 125,
      disk: 34
    }
  },
  {
    id: 'container-002',
    name: 'tensorflow-training',
    type: 'model',
    status: 'running',
    image: 'tensorflow/tensorflow:2.13.0-gpu',
    spec: {
      cpu: '8 vCPU',
      memory: '32 GB',
      gpu: 'NVIDIA V100 32GB',
      storage: '200 GB SSD'
    },
    ip: '10.0.1.23',
    port: 6006,
    billing: {
      type: 'monthly',
      cost: 450,
      currency: 'USD'
    },
    tags: ['TensorFlow', '模型训练', 'GPU'],
    createdAt: '2024-12-15T10:15:00Z',
    uptime: '4天12小时',
    resources: {
      cpu: 76,
      memory: 89,
      gpu: 95,
      network: 89,
      disk: 67
    }
  },
  {
    id: 'container-003',
    name: 'jupyter-notebook',
    type: 'development',
    status: 'stopped',
    image: 'jupyter/datascience-notebook:latest',
    spec: {
      cpu: '2 vCPU',
      memory: '8 GB',
      gpu: 'None',
      storage: '50 GB SSD'
    },
    ip: null,
    port: null,
    billing: {
      type: 'hourly',
      cost: 0.8,
      currency: 'USD'
    },
    tags: ['Jupyter', '数据科学', 'Python'],
    createdAt: '2024-12-18T16:45:00Z',
    uptime: '0小时',
    resources: {
      cpu: 0,
      memory: 0,
      gpu: 0,
      network: 0,
      disk: 12
    }
  }
]

// 模拟镜像数据
const mockImages = [
  {
    id: 'image-001',
    name: 'my-pytorch-env',
    tag: 'v1.2.0',
    size: '4.2 GB',
    type: 'development',
    description: '自定义PyTorch开发环境，包含常用深度学习库',
    status: 'ready',
    visibility: 'private',
    downloads: 0,
    stars: 0,
    tags: ['PyTorch', 'CUDA', '深度学习'],
    author: {
      name: '当前用户',
      avatar: 'https://picsum.photos/50/50?random=200'
    },
    createdAt: '2024-12-18T14:30:00Z',
    updatedAt: '2024-12-18T14:30:00Z'
  },
  {
    id: 'image-002',
    name: 'chatbot-api',
    tag: 'v2.1.5',
    size: '2.8 GB',
    type: 'model',
    description: '基于Transformer的聊天机器人API服务',
    status: 'ready',
    visibility: 'public',
    downloads: 156,
    stars: 23,
    tags: ['聊天机器人', 'API', 'NLP'],
    author: {
      name: '当前用户',
      avatar: 'https://picsum.photos/50/50?random=200'
    },
    createdAt: '2024-12-15T09:20:00Z',
    updatedAt: '2024-12-17T11:15:00Z'
  },
  {
    id: 'image-003',
    name: 'opencv-processor',
    tag: 'latest',
    size: '3.5 GB',
    type: 'development',
    description: '计算机视觉处理环境，集成OpenCV和相关工具',
    status: 'building',
    visibility: 'private',
    downloads: 0,
    stars: 0,
    tags: ['OpenCV', '计算机视觉', '图像处理'],
    author: {
      name: '当前用户',
      avatar: 'https://picsum.photos/50/50?random=200'
    },
    createdAt: '2024-12-19T09:45:00Z',
    updatedAt: '2024-12-19T09:45:00Z'
  }
]

// 模拟分类数据
const mockCategories = [
  { id: 'nlp', name: '自然语言处理', count: 45, icon: 'el-icon-chat-dot-round' },
  { id: 'computer_vision', name: '计算机视觉', count: 38, icon: 'el-icon-view' },
  { id: 'audio', name: '语音处理', count: 22, icon: 'el-icon-microphone' },
  { id: 'multimodal', name: '多模态', count: 15, icon: 'el-icon-picture-outline' },
  { id: 'robotics', name: '机器人学', count: 12, icon: 'el-icon-cpu' },
  { id: 'recommendation', name: '推荐系统', count: 18, icon: 'el-icon-star-on' }
]

// ======================== 模拟API函数 ========================

// 延迟函数，模拟网络请求
const mockDelay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms))

// 模拟成功响应
const mockResponse = (data) => ({
  data,
  code: 200,
  message: 'success'
})

// 模型相关API
export async function getModels(params = {}) {
  await mockDelay()
  let result = [...mockModels]
  
  // 模拟分页
  const page = params.page || 1
  const limit = params.limit || 10
  const start = (page - 1) * limit
  const end = start + limit
  
  // 模拟搜索
  if (params.search) {
    result = result.filter(model => 
      model.name.toLowerCase().includes(params.search.toLowerCase()) ||
      model.description.toLowerCase().includes(params.search.toLowerCase())
    )
  }
  
  // 模拟分类筛选
  if (params.category) {
    result = result.filter(model => model.category === params.category)
  }
  
  return mockResponse({
    items: result.slice(start, end),
    total: result.length,
    page,
    limit
  })
}

export async function getModelById(id) {
  await mockDelay()
  const model = mockModels.find(m => m.id == id)
  if (!model) {
    throw new Error('模型不存在')
  }
  return mockResponse(model)
}

export async function getModelCategories() {
  await mockDelay()
  return mockResponse(mockCategories)
}

export async function getHotModels(params = {}) {
  await mockDelay()
  const limit = params.limit || 6
  const hotModels = mockModels
    .sort((a, b) => b.views - a.views)
    .slice(0, limit)
  return mockResponse(hotModels)
}

export async function getTrendingModels(params = {}) {
  await mockDelay()
  const limit = params.limit || 6
  const trendingModels = mockModels
    .sort((a, b) => b.downloads - a.downloads)
    .slice(0, limit)
  return mockResponse(trendingModels)
}

export async function getPotentialModels(params = {}) {
  await mockDelay()
  const limit = params.limit || 6
  const potentialModels = mockModels
    .filter(model => new Date(model.updatedAt) > new Date('2024-12-15'))
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    .slice(0, limit)
  return mockResponse(potentialModels)
}

export async function searchModels(params) {
  return getModels(params)
}

export async function deployModel(data) {
  data
  await mockDelay(1000)
  return mockResponse({
    id: 'deploy-' + Date.now(),
    status: 'pending',
    message: '模型部署请求已提交'
  })
}

// 容器相关API
export async function getContainers(params = {}) {
  await mockDelay()
  let result = [...mockContainers]
  
  // 模拟筛选
  if (params.status) {
    result = result.filter(container => container.status === params.status)
  }
  if (params.type) {
    result = result.filter(container => container.type === params.type)
  }
  
  return mockResponse(result)
}

export async function getContainerById(id) {
  await mockDelay()
  const container = mockContainers.find(c => c.id === id)
  if (!container) {
    throw new Error('容器不存在')
  }
  return mockResponse(container)
}

export async function createContainer(data) {
  await mockDelay(1500)
  const newContainer = {
    id: 'container-' + Date.now(),
    name: data.name,
    type: data.type,
    status: 'creating',
    image: data.image,
    spec: data.spec,
    createdAt: new Date().toISOString()
  }
  return mockResponse(newContainer)
}

export async function updateContainer(id, data) {
  await mockDelay()
  return mockResponse({ id, ...data, updatedAt: new Date().toISOString() })
}

export async function deleteContainer(id) {
  await mockDelay()
  return mockResponse({ id, status: 'deleted' })
}

export async function startContainer(id) {
  await mockDelay(800)
  return mockResponse({ id, status: 'starting' })
}

export async function stopContainer(id) {
  await mockDelay(600)
  return mockResponse({ id, status: 'stopping' })
}

export async function restartContainer(id) {
  await mockDelay(1000)
  return mockResponse({ id, status: 'restarting' })
}

export async function getContainerLogs(id, params) {
  params
  await mockDelay()
  const logs = [
    '2024-12-19 10:30:15 [INFO] Container started successfully',
    '2024-12-19 10:30:16 [INFO] Loading model...',
    '2024-12-19 10:30:20 [INFO] Model loaded, ready to serve requests',
    '2024-12-19 10:31:05 [INFO] Processing request from 10.0.1.100',
    '2024-12-19 10:31:06 [INFO] Request completed in 1.2s'
  ]
  return mockResponse(logs)
}

export async function getContainerMonitor(id, params) {
  params
  await mockDelay()
  const container = mockContainers.find(c => c.id === id)
  return mockResponse({
    id,
    timestamp: new Date().toISOString(),
    resources: container?.resources || {}
  })
}

export async function getContainerStats(id) {
  await mockDelay()
  return mockResponse({
    id,
    uptime: '2天5小时',
    requests: 1250,
    errors: 3,
    avgResponseTime: 850
  })
}

// 镜像相关API
export async function getImages(params = {}) {
  await mockDelay()
  let result = [...mockImages]
  
  if (params.type) {
    result = result.filter(image => image.type === params.type)
  }
  if (params.visibility) {
    result = result.filter(image => image.visibility === params.visibility)
  }
  
  return mockResponse(result)
}

export async function getImageById(id) {
  await mockDelay()
  const image = mockImages.find(i => i.id === id)
  if (!image) {
    throw new Error('镜像不存在')
  }
  return mockResponse(image)
}

export async function uploadImage(data) {
  await mockDelay(2000)
  const newImage = {
    id: 'image-' + Date.now(),
    name: data.name || 'unnamed-image',
    tag: data.tag || 'latest',
    status: 'uploading',
    createdAt: new Date().toISOString()
  }
  return mockResponse(newImage)
}

export async function getMyModels(params) {
  params
  await mockDelay()
  return mockResponse(mockContainers)
}

export async function updateImage(id, data) {
  await mockDelay()
  return mockResponse({ id, ...data, updatedAt: new Date().toISOString() })
}

export async function getMyImages(params) {
  params
  await mockDelay()
  return mockResponse(mockImages)
}

export async function deleteImage(id) {
  await mockDelay()
  return mockResponse({ id, status: 'deleted' })
}

export async function buildImage(data) {
  data
  await mockDelay(3000)
  return mockResponse({
    id: 'build-' + Date.now(),
    status: 'building',
    message: '镜像构建已开始'
  })
}

export async function getImageHistory(id) {
  id
  await mockDelay()
  const history = [
    { version: 'v1.2.0', createdAt: '2024-12-18T14:30:00Z', size: '4.2 GB' },
    { version: 'v1.1.0', createdAt: '2024-12-15T09:20:00Z', size: '4.0 GB' },
    { version: 'v1.0.0', createdAt: '2024-12-10T11:45:00Z', size: '3.8 GB' }
  ]
  return mockResponse(history)
}

export async function shareImage(id, data) {
  await mockDelay()
  return mockResponse({ id, shared: true, ...data })
}

// 资源规格相关API
export async function getResourceSpecs() {
  await mockDelay()
  const specs = [
    { name: 'Basic', cpu: '2 vCPU', memory: '8 GB', gpu: 'None', price: 0.5 },
    { name: 'Standard', cpu: '4 vCPU', memory: '16 GB', gpu: 'GTX 1080', price: 1.2 },
    { name: 'Pro', cpu: '8 vCPU', memory: '32 GB', gpu: 'RTX 4090', price: 2.8 },
    { name: 'Enterprise', cpu: '16 vCPU', memory: '64 GB', gpu: 'A100 40GB', price: 5.5 }
  ]
  return mockResponse(specs)
}

export async function getResourceUsage(params) {
  params
  await mockDelay()
  return mockResponse({
    cpu: { used: 45, total: 100 },
    memory: { used: 32, total: 64 },
    gpu: { used: 2, total: 4 },
    storage: { used: 120, total: 500 }
  })
}

export async function getResourceQuota() {
  await mockDelay()
  return mockResponse({
    containers: { used: 3, limit: 10 },
    cpu: { used: 14, limit: 32 },
    memory: { used: 56, limit: 128 },
    storage: { used: 350, limit: 1000 }
  })
}

// 其他API保持原样，但添加模拟延迟
export async function getBillingInfo(params) {
  params
  await mockDelay()
  return mockResponse({
    currentMonth: 245.67,
    lastMonth: 189.23,
    yearToDate: 2156.89
  })
}

export async function getBillingHistory(params) {
  params
  await mockDelay()
  const history = [
    { date: '2024-12', amount: 245.67, status: 'current' },
    { date: '2024-11', amount: 189.23, status: 'paid' },
    { date: '2024-10', amount: 234.56, status: 'paid' }
  ]
  return mockResponse(history)
}

export async function getBillingEstimate(data) {
  data
  await mockDelay()
  return mockResponse({
    estimatedCost: 125.50,
    breakdown: {
      compute: 89.20,
      storage: 23.40,
      network: 12.90
    }
  })
}

// 保持其他函数不变，只是添加模拟延迟
export async function getUserProfile() {
  await mockDelay()
  return mockResponse({
    id: 1,
    name: '张三',
    email: 'zhangsan@example.com',
    avatar: 'https://picsum.photos/100/100?random=300'
  })
}

export async function updateUserProfile(data) {
  await mockDelay()
  return mockResponse(data)
}

export async function getUserApiKeys() {
  await mockDelay()
  return mockResponse([
    { id: 1, name: 'Default Key', key: 'ak_****1234', createdAt: '2024-12-01' }
  ])
}

export async function createApiKey(data) {
  await mockDelay()
  return mockResponse({ id: Date.now(), ...data })
}

export async function deleteApiKey(id) {
  await mockDelay()
  return mockResponse({ id, deleted: true })
}

export async function getTasks(params) {
  params
  await mockDelay()
  return mockResponse([])
}

export async function getTaskById(id) {
  await mockDelay()
  return mockResponse({ id, status: 'completed' })
}

export async function createTask(data) {
  await mockDelay()
  return mockResponse({ id: Date.now(), ...data })
}

export async function cancelTask(id) {
  await mockDelay()
  return mockResponse({ id, status: 'cancelled' })
}

export async function getTaskLogs(id, params) {
  params
  await mockDelay()
  return mockResponse(['Task started', 'Task completed'])
}

export async function getNotifications(params) {
  params
  await mockDelay()
  return mockResponse([])
}

export async function markNotificationRead(id) {
  await mockDelay()
  return mockResponse({ id, read: true })
}

export async function markAllNotificationsRead() {
  await mockDelay()
  return mockResponse({ success: true })
}

export async function getDashboardStats() {
  await mockDelay()
  return mockResponse({
    containers: 3,
    models: 8,
    images: 5,
    usage: { cpu: 45, memory: 68, gpu: 82 }
  })
}

export async function getUsageAnalytics(params) {
  params
  await mockDelay()
  return mockResponse({
    daily: [120, 89, 156, 203, 178, 234, 189]
  })
}

export async function getCostAnalytics(params) {
  params
  await mockDelay()
  return mockResponse({
    daily: [45.6, 67.8, 89.2, 56.7, 78.9, 92.1, 67.5]
  })
}

export async function getPerformanceAnalytics(params) {
  params
  await mockDelay()
  return mockResponse({
    avgResponseTime: 850,
    throughput: 1250,
    errorRate: 0.24
  })
} 